import Sidebar from "../components/SidebarUpdate";
import { useEffect, useState } from "react";
import { ClipLoader } from "react-spinners";
import apiInstance from "../apiConfig/apiinstance";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

function SearchDetailpage() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const location = useLocation();
  const searchQuery = new URLSearchParams(location.search).get("name");
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSearchResults = async () => {
      setLoading(true);
      setError(null);
      try {
        const { data } = await apiInstance.get(
          `/api/style/v1/style/?name=${searchQuery}`
        );
        if (data.status === 200) {
          setData(data.data.results || []);
          if (data.data.results.length === 0) {
            setError("No results found for your search.");
          }
        } else {
          setError("No results found for your search.");
        }
      } catch (error) {
        setError(
          error?.response?.data?.message || "Failed to fetch search results"
        );
      } finally {
        setLoading(false);
      }
    };

    if (searchQuery) {
      fetchSearchResults();
    }
  }, [searchQuery]);

  const handleStyleClick = (slug) => {
    navigate(`/search/product-detail/${slug}`);
  };

  return (
    <div className="parent_Container">
      <div className="content_wrapper py-4 px-8">
        <Sidebar logo="FP ONE" />
        <div className="content_wrapper_child overflow-hidden">
          <div className="separator"></div>

          {loading ? (
            <div className="loader-container">
              <ClipLoader color="#3498db" loading={loading} size={50} />
            </div>
          ) : (
            <div className="p-4">
              {error && (
                <div className="no-products loader-container">{error}</div>
              )}

              <div className="flex gap-4 flex-wrap">
                {data?.map((item) => (
                  <div
                    key={item.msr_season_id}
                    className="msr_container"
                    onClick={() => handleStyleClick(item.style_id)}
                  >
                    <img
                      src={item.cover_image}
                      className="image"
                      alt={`${item.season_name}`}
                    />
                    {/* <span className="font-bold">{item.name}</span> */}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SearchDetailpage;
